import { eventDateFormatter } from "@/components/pdp/pdpComponents/utils";
import { baseApi } from "./apiConfig";
import axios from "axios";
import { InvestmentCalcPrefix, InvestmentCalcURL } from "@/setting";

let rentalEstimateCancelToken;

export const getPDPInitData = (id) => {
  return baseApi.get(`/portal/property/getNewPdpDetails/${id}`).then(
    (response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return null;
    },
    (error) => {
      if (error?.response?.status === 404) {
        return { propertyDetails: null, errorMessage: "Property not found" };
      }
      return null;
    }
  );
};

export const getDisclaimer = (id) => {
  return baseApi.get(`/portal/pdp-disclaimers/${id}`).then((response) => {
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  });
};



export const birdseyeSaveLead = async (payload) => {
  try {
    const response = await baseApi.post(
      `/portal/saveLead`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const getInspectionContingency = (
  sellerId,
  propCategory,
  occupancy,
  listingType,
  propertyId
) => {
  var occupancyStatus = "";
  if (occupancy === false) {
    occupancyStatus = "VACANT";
  } else {
    occupancyStatus = "OCCUPIED";
  }
  return baseApi

    .get(
      `/portal/inspection-contingency-disclaimer/${sellerId}/${propCategory}/${occupancyStatus}/${listingType}?propertyId=${propertyId}`
    )
    .then((response) => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === "SUCCESS"
      ) {
        // console.log("responsepdp>>>>",response);
        return response.data;
      }
      return null;
    });
};
export const getRentalEstimate = (id) => {
  if (typeof rentalEstimateCancelToken != typeof undefined) {
    rentalEstimateCancelToken.cancel("Operation canceled due to new request.");
  }
  rentalEstimateCancelToken = axios.CancelToken.source();
  return baseApi
    .get(`/property/rentRangeDetails/${id}`, {
      cancelToken: rentalEstimateCancelToken.token,
    })
    .then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return null;
    });
};

export const getAds = (id) => {
  return baseApi.get(`/portal/getPdpEnabledAds/${id}`).then((response) => {
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  });
};

export const getEMD = (id) => {
  return baseApi
    .get(`/portal/emd-for-all-financetypes/${id}`)
    .then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return null;
    });
};

export const getPriceHistory = (id) => {
  return baseApi.get(`/portal/priceHistory/${id}`).then((response) => {
    if (response?.status === 200) {
      return response.data;
    }
    return null;
  });
};

export const getTax = (id) => {
  return baseApi.get(`/portal/taxRecord/${id}`).then((response) => {
    if (response?.status === 200) {
      return response.data;
    }
    return null;
  });
};

export const getCMS = (path) => {
  return baseApi
    .get(
      encodeURI(`portal/get-new-cms-data/hubzuweb?template=/hubzuweb/${path}`)
    )
    .then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return null;
    });
};

export const getWebCMS = (path) => {
  return baseApi
    .get(
      encodeURI(`portal/get-new-cms-data/hubzuweb?template=/hubzuweb/${path}`)
    )
    .then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return null;
    });
};
export const getBidCenterDetails = (id) => {
  return baseApi.get(`/portal/getBidCenterDetails/${id}`).then((response) => {
    if (response?.status === 200) {
      return response?.data;
    }
    return null;
  });
};

export const hasUserAcceptedForeClosureDocument = (id) => {
  return baseApi.get(`/portal/hasUserAcceptedForeClosureDocument/${id}`).then((response) => {
    if (response?.status === 200) {
      return response?.data;
    }
    return null;
  });
};





export const getEventCalendarDetails = (
  state,
  eventFromDate,
  eventToDate,
  pageNumber
) => {
  // query params
  const params = {};

  if (state) params.state = state;

  if (eventFromDate) {
    const formattedDate = eventDateFormatter(eventFromDate);
    params.eventFromDate = formattedDate;
  }
  if (eventToDate) {
    const formattedDate = eventDateFormatter(eventToDate);
    params.eventToDate = formattedDate;
  }

  if (pageNumber && pageNumber > 1) params.pageNumber = pageNumber;

  params.jsonResponse = true;

  // added timestamp to avoid caching issue
  params._ = Date.now();

  return baseApi
    .get("portal/foreclosure/getEventCalendarDetails", { params })
    .then((response) => {
      if (response?.status === 200) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      console.error("Error fetching event calendar details:", error);
      return null;
    });
};

export const getActiveEventsCount = (state, eventFromDate, eventToDate) => {
  // query params
  const params = {};

  if (state) params.state = state;

  if (eventFromDate) {
    const formattedDate = eventDateFormatter(eventFromDate);
    params.eventFromDate = formattedDate;
  }
  if (eventToDate) {
    const formattedDate = eventDateFormatter(eventToDate);
    params.eventToDate = formattedDate;
  }

  // added timestamp to avoid caching issue
  params._ = Date.now();

  return baseApi
    .get("portal/foreclosure/getActiveEventsCount", { params })
    .then((response) => {
      if (response?.status === 200) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      console.error("Error fetching active events count:", error);
      return null;
    });
};

export const getActiveEventDates = () => {
  return baseApi
    .get("portal/foreclosure/getEventDates")
    .then((response) => {
      if (response && response.status === 200) {
        return response?.data;
      }
      return null;
    })
    .catch((error) => {
      console.error("Error fetching active event dates:", error);
      return null;
    });
};

export const getActiveEventState = (state, eventFromDate, eventToDate) => {
  // query params
  const params = {};

  if (eventFromDate) {
    const formattedDate = eventDateFormatter(eventFromDate);
    params.eventFromDate = formattedDate;
  }
  if (eventToDate) {
    const formattedDate = eventDateFormatter(eventToDate);
    params.eventToDate = formattedDate;
  }

  // added timestamp to avoid caching issue
  params._ = Date.now();

  return baseApi
    .get("portal/foreclosure/getEventStateMapByEventDate", { params })
    .then((response) => {
      if (response && response.status === 200) {
        return response?.data;
      }
      return null;
    })
    .catch((error) => {
      console.error("Error fetching active states:", error);
      return null;
    });
};

export const getLatestBidCenter = (id) => {
  return baseApi.post(`/portal/latestBidCenter/${id}`).then((response) => {
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  });
};

export const getBidHistory = (id) => {
  return baseApi.get(`/portal/bidHistory/${id}`).then((response) => {
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  });
};

export const getSchoolInfo = (id) => {
  return baseApi.get(`/portal/V2.0/schoolInfo/${id}`).then((response) => {
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  });
};

export const getSchoolList = (id) => {
  return baseApi.get(`/portal/V2.0/schoolInfo/${id}`).then((response) => {
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  });
};

export const getInvestmentData = (id) => {
  // return axios.get(`${InvestmentCalcPrefix}/${InvestmentCalcURL}/${id}`, {  //Enable this line for local
  return axios.get(`/${InvestmentCalcURL}/${id}`, {
    headers:{Accept: "application/json"}})
    .then((response) => {
      if (response?.status === 200) {
        return response?.data;
      }
      return null;
    });
};

export const getUserAction = (id) => {
  console.log('id -> ', id);
  try {
    return baseApi

      .get("/portal/checkOfferStatusByListingId/" + id)
      .then((response) => {
        if (response) {
          return response;
        }
        return null;
      })
      .catch((error) => {
        return null;
      });
  } catch (e) {
    return null;
  }
};

export const getSmsWatchData = (propertyId) => {
  return baseApi

    .get(`/portal/getSmsWatchData?propertyId=${propertyId}`)
    .then((response) => {
      if (response && response.status === 200) {
        return response;
      }
      return null;
    });
};

export const updateSmsWatchList = (body) => {
  const formdata = new FormData();
  formdata.append("propertyId", body.propertyId);
  formdata.append("updateFlag", body.updateFlag);
  return baseApi
    .post(`/portal/updateSmsWatchList`, formdata)
    .then((response) => {
      if (response && response.status === 200) {
        return response;
      }
      return null;
    });
};

export const getFCLatestBidCenter = (id) => {
  return baseApi
    .post(`/portal/latestBidCenter/${id}?isFcAuction=Y`)
    .then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return null;
    });
};

export const getFCAuctionBidCenterDetails = (id, status) => {
  var stats = "";
  if (status === "TRANSACTION_PENDING") {
    stats = "TRNS_PENDING";
  } else if (status === "TRANSACTION_COMPLETED") {
    stats = "TRNS_COMPLETED";
  } else {
    stats = status;
  }
  return baseApi
    .get(`/portal/getFcAuctionBidCenter/${id}/${stats}`)
    .then((response) => {
      if (response?.status === 200) {
        return response?.data;
      }
      return null;
    });
};
export const getPropertyDetails = (listingId) => {
  return baseApi
    .post(`/portal/v2.0/getPropertyDetail/${listingId}`)
    .then((response) => {
      return response.data;
    })
    .catch((e) => { });
};

export const isUserAuthorised = async (listingId) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(`/portal/lean-regn/isUserAuthorized/${listingId}`, {
      params: {
        _: timestamp
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting bid details:', error);
    throw error;
  }
};

export const saveUserAcceptanceForeClosureDocument = (propertyId) => {
  const formdata = new FormData();
  formdata.append("propertyId", propertyId);
  return baseApi
    .post(`/portal/saveUserAcceptanceForeClosureDocument`, formdata)
    .then((response) => {
      if (response && response.status === 200) {
        return response?.data;
      }
      return null;
    });
};

// export const isUserAuthorised = (listingId) => {
//   return baseApi
//     .post(`/portal/lean-regn/isUserAuthorized/${listingId}`)
//     .then((response) => {
//       return response.data;
//     })
//     .catch((e) => {});
// };

export const acceptNDA = (id, userID) => {
  const body = { propertyId: id, userId: userID };
  return baseApi
    .post('/portal/save-nda-acceptance', body)
    .then(response => {
      // log('PDP API:', response);
      if (response.status === 200) {
        return response.data;
      }
      return null;
    });
};

export const saveBuyerProfileForNDA = (payload) => {

  return baseApi
    .post(`/portal/lean-regn/saveBuyerProfileForNDA`, payload)
    .then((response) => {
      if (response && response.status === 200) {
        return response?.data;
      }
      return null;
    });
};


export const postSmsFlag = async (path, number) => {
  try {
    const cookies = document.cookie;
    const body = { phoneNumber: number };
    return baseApi
      .post(`/portal/lean-regn/${path}`, body, {
        header: {
          Cookies: cookies,
        },
      })
      .then((response) => {
        // log("postSaveUserSmsOptOutFlag:", response);
        if (response && response.status === 200) {
          return response;
        }
        return null;
      });
  } catch (e) {
    // log("API IS DOWN");
  }
};

export const updatePropertyViewCount = async (prpertyId, listingId) => {
  try {
    const cookies = document.cookie;
   
    return baseApi
      .post(`/portal/updatePropertyViewCount/${prpertyId}/${listingId}`, {
        header: {
          Cookies: cookies,
        },
      })
      .then((response) => {
        // log("postSaveUserSmsOptOutFlag:", response);
        if (response && response.status === 200) {
          return response;
        }
        return null;
      });
  } catch (e) {
    // log("API IS DOWN");
  }
};

export const getPDPPrint = async ({ propertyId }) => {
  try {
    const response = await baseApi.get(`/portal/printPDPDetails/${propertyId}`, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/pdf'
      }
    });
    const { status, data } = response;
    // show pdf in new tab
    if (status === 200) {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } else {
      throw response;
    }

  } catch (error) {
    console.error('PDP Print error', error);
  }
};


export const downloadCommercialDocument = async (item) => {
  try {
    const timestamp = new Date().getTime();

    const docId = item['fileListId'];

    console.log('docId = ', docId);

    const response = await baseApi.get(`portal/property/getDocument/${docId}`, {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/octet-stream', // or '*/*'
      },
      params: {
        _: timestamp,
      },
    });

    const { status, data } = response;

    if (status === 200) {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${item?.documentName}.pdf`); // You can customize the filename
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Clean up the object URL
      window.URL.revokeObjectURL(url);
    } else {
      throw new Error(`Unexpected response status: ${status}`);
    }
  } catch (error) {
    console.error('Download error:', error);
  }
};


export const getNearbyProperties = async (id) => {
  try {
    const response = await baseApi.get(`/portal/nearbyProperties/${id}`);
    const { status, data } = response;
    if (status === 200) {
      return data?.nearbyPropertyList || [];
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error in getNearbyProperties", error);
  }
};
export const contactAgent =async(payload)=>{
try {
  const response = await baseApi.post("/portal/contactAgent", payload);
  return response.data;
} catch (error) {
  console.error("Error while submitting contact agent form",error);
  
}
}

export const recordFolderView = (propertyId, folderKey) =>
  baseApi.post(`/portal/property/vault-progress/${propertyId}/folder-view`, { folderKey })
    .then(res => res.status === 200 ? res.data : null)
    .catch(() => null);

// Due Diligence Vault API helpers — fail silently so progress tracking never blocks document access

export const getVaultProgress = (propertyId) =>
  baseApi.get(`/portal/property/vault-progress/${propertyId}`)
    .then(res => res.status === 200 ? res.data : null)
    .catch(() => null);

export const saveDocumentReadPercentage = (propertyId, documentReadPercentage) =>
  baseApi.post(`/portal/property/save-document-read-percentage`, {
    propertyId,
    documentReadPercentage: String(documentReadPercentage),
  })
    .then(res => res.status === 200 ? res.data : null)
    .catch(() => null);

export const savePropertyDocumentUserRead = (propertyId, fileListId) =>
  baseApi.post(`/portal/property/save-property-document-user-read`, {
    propertyId,
    fileListId,
  })
    .then(res => res.status === 200 ? res.data : null)
    .catch(() => null);


export const getCommuterScore = (propertyId) => {
  return baseApi
    .get(`/portal/api/commuter-score/${propertyId}`)
    .then((response) => {
      if (response?.status === 200 && response.data?.status === "SUCCESS") {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      console.error("Error fetching commuter score:", error);
      return null;
    });
};
